module.exports = __webpack_public_path__ + "assets/images/X-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/X-route-sheet.png
// module id = 1472
// module chunks = 1